<template>
	<section
		:class="[
			'card card-payout',
			{ active: displayFormPayout, company: userData.isCompany },
		]"
	>
		<h2 @click="showForm()">
			wypłać z rachunku fx
			<img
				src="images/icons/chevron-down-green.svg"
				:class="{ 'upside-down': displayFormPayout }"
			/>
		</h2>
		<TransitionGroup tag="div" name="card-collapse" mode="out-in">
			<keep-alive :key="1">
				<payout-form v-if="displayFormPayout" :key="2" />
				<payout-preview v-else :key="3" />
			</keep-alive>
		</TransitionGroup>
	</section>
</template>

<script>
import PayoutForm from '@/views/dashboard/partial/_PayoutForm';
import PayoutPreview from '@/views/dashboard/partial/_PayoutPreview';

export default {
	components: {
		PayoutForm,
		PayoutPreview,
	},
	methods: {
		showForm() {
			this.$store.commit('setDisplayFormFastPayment', false);
			this.$store.commit('setDisplayFormPayout', !this.displayFormPayout);
			this.$store.commit('setDisplayFormAccounts', false);
		},
	},
	computed: {
		displayFormPayout() {
			return this.$store.getters.getDisplayFormPayout;
		},
		userData() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
	},
};
</script>
